const states = {
	defaults: {},
	skills: [],
	categories: {},
	portfolio: [],
	exp: []
};

export default states;
